import Board from "@asseinfo/react-kanban";
import styled from "@emotion/styled";

const StyledBoard = styled(Board)`
  display: flex;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 16px;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Board layout responsive changes */
  .react-kanban-board {
    display: flex;
    width: 100%;
  }

  .react-kanban-column {
    /* Base column styles */
    min-width: 280px;
    flex: 0 0 auto;

    /* Tablet responsive styles */
    @media (min-width: 600px) and (max-width: 1024px) {
      min-width: 240px !important;
      margin: 0 6px !important;
      padding: 12px !important;
    }

    /* Small tablet/large phone responsive styles */
    @media (max-width: 768px) {
      min-width: 220px !important;
      margin: 0 4px !important;
      padding: 10px !important;
    }
  }

  /* Drag improvements */
  .react-kanban-card-skeleton {
    position: absolute;
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
  }

  .react-kanban-card--dragging {
    transform-origin: center center;
    transition: transform 0.1s;
    cursor: grabbing;
    user-select: none;
    touch-action: none;
    opacity: 0.8;
  }

  /* Better touch handling */
  .react-kanban-card {
    touch-action: pan-y;
  }
`;
export default StyledBoard;
